function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8383"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8383"] = parcelRequire;
}
parcelRequire.register("1Zafa", function(module, exports) {

$parcel$export(module.exports, "register", () => $17236f1e82b576e0$export$6503ec6e8aabbaf, (v) => $17236f1e82b576e0$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $17236f1e82b576e0$export$f7ad0328861e2f03, (v) => $17236f1e82b576e0$export$f7ad0328861e2f03 = v);
var $17236f1e82b576e0$export$6503ec6e8aabbaf;
var $17236f1e82b576e0$export$f7ad0328861e2f03;
"use strict";
var $17236f1e82b576e0$var$mapping = {};
function $17236f1e82b576e0$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$17236f1e82b576e0$var$mapping[keys[i]] = pairs[keys[i]];
}
function $17236f1e82b576e0$var$resolve(id) {
    var resolved = $17236f1e82b576e0$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$17236f1e82b576e0$export$6503ec6e8aabbaf = $17236f1e82b576e0$var$register;
$17236f1e82b576e0$export$f7ad0328861e2f03 = $17236f1e82b576e0$var$resolve;

});

var $679dc944dbae40d4$exports = {};

(parcelRequire("1Zafa")).register(JSON.parse('{"1LzKV":"index.c7837b82.js","gJ2Mn":"worker.e40a746a.js"}'));

function $b03bd32f017d14a0$var$fixProto(target, prototype) {
    var setPrototypeOf = Object.setPrototypeOf;
    setPrototypeOf ? setPrototypeOf(target, prototype) : target.__proto__ = prototype;
}
function $b03bd32f017d14a0$var$fixStack(target, fn) {
    if (fn === void 0) fn = target.constructor;
    var captureStackTrace = Error.captureStackTrace;
    captureStackTrace && captureStackTrace(target, fn);
}
var $b03bd32f017d14a0$var$__extends = function() {
    var _extendStatics = function extendStatics(d, b) {
        _extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return _extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        _extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $b03bd32f017d14a0$export$f7a70f5f17339408 = function(_super) {
    $b03bd32f017d14a0$var$__extends(CustomError, _super);
    function CustomError(message, options) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message, options) || this;
        Object.defineProperty(_this, "name", {
            value: _newTarget.name,
            enumerable: false,
            configurable: true
        });
        $b03bd32f017d14a0$var$fixProto(_this, _newTarget.prototype);
        $b03bd32f017d14a0$var$fixStack(_this);
        return _this;
    }
    return CustomError;
}(Error);
var $b03bd32f017d14a0$var$__spreadArray = function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
function $b03bd32f017d14a0$export$aa5f2b9aeca47350(fn, parent) {
    if (parent === void 0) parent = Error;
    function CustomError() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (!(this instanceof CustomError)) return new (CustomError.bind.apply(CustomError, $b03bd32f017d14a0$var$__spreadArray([
            void 0
        ], args, false)))();
        parent.apply(this, args);
        Object.defineProperty(this, "name", {
            value: fn.name || parent.name,
            enumerable: false,
            configurable: true
        });
        fn.apply(this, args);
        $b03bd32f017d14a0$var$fixStack(this, CustomError);
    }
    return Object.defineProperties(CustomError, {
        prototype: {
            value: Object.create(parent.prototype, {
                constructor: {
                    value: CustomError,
                    writable: true,
                    configurable: true
                }
            })
        }
    });
}


class $5d20b07d0690626b$export$3dcec14de97dcce2 extends (0, $b03bd32f017d14a0$export$f7a70f5f17339408) {
    constructor(retryAfterHeader){
        super("Ratelimit exceeded");
        this.retryAfter = null;
        if (!retryAfterHeader) return;
        if (/^\d+$/.test(retryAfterHeader)) this.retryAfter = parseInt(retryAfterHeader);
        else this.retryAfter = Math.max(Number(new Date(retryAfterHeader)) - Number(new Date()), 0);
    }
}
class $5d20b07d0690626b$export$1a6b7111629cfd6e {
    #delay;
    nextRequest() {
        this.#delay = 250;
    }
    canDelay() {
        return this.#delay < 60000;
    }
    makeDelay() {
        return new Promise((r)=>setTimeout(r, this.#delay));
    }
    recordError(e) {
        if (e.retryAfter) this.#delay = e.retryAfter;
        else this.#delay *= 2;
        console.info(`Next delay: ${this.#delay / 1000}s`);
    }
    constructor(){
        this.#delay = 250;
    }
}


const $b187e061564ac6c6$export$8bab5df56b6634b2 = "https://logs.ivr.fi";
async function $b187e061564ac6c6$export$4e99851808bd6c98(justlogUrl, channel, user, userID) {
    const res = await fetch(`${justlogUrl}/list?${new URLSearchParams(userID.length !== 0 ? {
        channel: channel,
        userid: userID
    } : {
        channel: channel,
        user: user
    }).toString()}`);
    const capabilities = $b187e061564ac6c6$var$getCapabilities(res);
    if (!res.ok) throw new Error(await res.text().catch((e)=>e.toString()));
    const json = await res.json();
    return {
        logs: json.availableLogs,
        capabilities: capabilities
    };
}
function $b187e061564ac6c6$export$d379edd7759cd0b(log) {
    return new Date(Date.UTC(Number(log.year), Number(log.month) - 1));
}
function $b187e061564ac6c6$export$47fadecd4063c2d1(log) {
    return new Date(Date.UTC(Number(log.year), Number(log.month)));
}
function $b187e061564ac6c6$var$availableLogMonth(log) {
    return 12 * Number(log.year) + Number(log.month);
}
function $b187e061564ac6c6$export$b6187d7c6d2d4478(a, b) {
    return $b187e061564ac6c6$var$availableLogMonth(a) - $b187e061564ac6c6$var$availableLogMonth(b);
}
function $b187e061564ac6c6$export$b4de88d64f732d22(justlogUrl, channel, user, year, month) {
    const encode = encodeURIComponent;
    return $b187e061564ac6c6$var$getAnyLogs(`${justlogUrl}/channel/${encode(channel)}/user/${encode(user)}/${encode(year)}/${encode(month)}`);
}
function $b187e061564ac6c6$export$d63ce7feae4bfcdc(justlogUrl, channel, userID, year, month) {
    const encode = encodeURIComponent;
    return $b187e061564ac6c6$var$getAnyLogs(`${justlogUrl}/channel/${encode(channel)}/userid/${encode(userID)}/${encode(year)}/${encode(month)}`);
}
function $b187e061564ac6c6$export$3e93eca0c99bea47(justlogUrl, channel, user) {
    const encode = encodeURIComponent;
    const query = new URLSearchParams({
        from: new Date(0).toISOString(),
        to: new Date().toISOString()
    });
    return $b187e061564ac6c6$var$getAnyLogs(`${justlogUrl}/channel/${encode(channel)}/user/${encode(user)}?${query}`);
}
function $b187e061564ac6c6$export$1c5a2fa173500852(justlogUrl, channel, userID) {
    const encode = encodeURIComponent;
    const query = new URLSearchParams({
        from: new Date(0).toISOString(),
        to: new Date().toISOString()
    });
    return $b187e061564ac6c6$var$getAnyLogs(`${justlogUrl}/channel/${encode(channel)}/userid/${encode(userID)}?${query}`);
}
async function $b187e061564ac6c6$var$getAnyLogs(url) {
    const res = await fetch(url);
    if (res.status == 429) throw new (0, $5d20b07d0690626b$export$3dcec14de97dcce2)(res.headers.get("Retry-After"));
    if (!res.ok) throw new Error(await res.text().catch((e)=>e.toString()));
    return res;
}
async function $b187e061564ac6c6$export$6e95cf02744120b(justlogUrl) {
    const res = await fetch(`${justlogUrl}/channels`);
    if (!res.ok) throw new Error(await res.text().catch((e)=>e.toString()));
    const json = await res.json();
    return json.channels;
}
function $b187e061564ac6c6$export$8b4efa0639cccf78(userUrl) {
    return userUrl.startsWith("http") ? userUrl : $b187e061564ac6c6$export$8bab5df56b6634b2;
}
function $b187e061564ac6c6$var$getCapabilities(res) {
    const header = res.headers.get("x-rustlog-capabilities") ?? "";
    if (!header) return [];
    return header.split(",").map((x)=>x.trim());
}


var $583f7dee51d6471d$exports = {};
var $7ddb53bde19d773e$exports = {};
"use strict";
$7ddb53bde19d773e$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? "import " + JSON.stringify(workerUrl) + ";" : "importScripts(" + JSON.stringify(workerUrl) + ");";
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: "application/javascript"
        }));
    }
};



let $583f7dee51d6471d$var$url = new URL((parcelRequire("1Zafa")).resolve("gJ2Mn"), import.meta.url);
$583f7dee51d6471d$exports = $7ddb53bde19d773e$exports($583f7dee51d6471d$var$url.toString(), $583f7dee51d6471d$var$url.origin, true);


function $4ee3c9a424eac42e$export$5d455722ec58f172(onMessage) {
    return {
        worker: null,
        postMessage (req) {
            if (this.worker == null) {
                this.worker = new Worker($583f7dee51d6471d$exports);
                this.worker.addEventListener("message", ({ data: data })=>onMessage(data));
            }
            this.worker.postMessage(req);
        }
    };
}


function $5be042668c706f09$export$da51b626bd37c807(el) {
    while(el.firstChild)// @ts-ignore -- last child will exist
    el.removeChild(el.lastChild);
}
function $5be042668c706f09$export$c8a8987d4410bf2d(type, ...classes) {
    const el = document.createElement(type);
    el.classList.add(...classes);
    return el;
}




const $a8b2668cf8297c62$var$MONTH_MAP = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
function* $a8b2668cf8297c62$export$16352d1b10c5eb38(start, end) {
    let d = new Date(start);
    while(d < end){
        yield new Date(d);
        d.setUTCMonth(d.getUTCMonth() + 1);
    }
}
function* $a8b2668cf8297c62$var$monthNames(start, end) {
    for (const date of $a8b2668cf8297c62$export$16352d1b10c5eb38(start, end))yield [
        $a8b2668cf8297c62$var$MONTH_MAP[date.getUTCMonth()],
        date
    ];
}
function* $a8b2668cf8297c62$var$years(start, end) {
    let startMonth = 0;
    let year = 0;
    let curr = 1;
    for (const date of $a8b2668cf8297c62$export$16352d1b10c5eb38(start, end)){
        if (date.getUTCFullYear() != year) {
            if (year) yield [
                year,
                [
                    startMonth,
                    curr
                ]
            ];
            year = date.getUTCFullYear();
            startMonth = curr;
        }
        curr++;
    }
    if (year) yield [
        year,
        [
            startMonth,
            curr
        ]
    ];
}
function $a8b2668cf8297c62$export$eb1c2751fdb81cab(host, start, end) {
    const columns = [];
    for (const [name, date] of $a8b2668cf8297c62$var$monthNames(start, end)){
        const el = document.createElement("div");
        el.classList.add("month-name");
        columns.push(`${$a8b2668cf8297c62$export$3eef6ded89f84b02(date)}px`);
        el.textContent = name;
        host.append(el);
    }
    host.style.setProperty("--cols", columns.join(" "));
    for (const [year, [mStart, mEnd]] of $a8b2668cf8297c62$var$years(start, end)){
        const el = (0, $5be042668c706f09$export$c8a8987d4410bf2d)("div", "year-name");
        el.textContent = year.toString();
        el.style.setProperty("--month-span", `${mStart} / ${mEnd}`);
        host.append(el);
    }
}
function $a8b2668cf8297c62$export$4169ecd548fbc13a(log) {
    const start = Number((0, $b187e061564ac6c6$export$d379edd7759cd0b)(log));
    const end = Number((0, $b187e061564ac6c6$export$47fadecd4063c2d1)(log));
    return (end - start) / 86400000;
}
function $a8b2668cf8297c62$export$3eef6ded89f84b02(date) {
    const start = Date.UTC(date.getUTCFullYear(), date.getUTCMonth());
    const end = Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + 1);
    return (end - start) / 86400000;
}
function $a8b2668cf8297c62$export$bd191d922aa33ab0(log) {
    return Number(log.year) << 5 | Number(log.month) - 1;
}
function $a8b2668cf8297c62$export$8deb5bf02e08eae3(date) {
    return Number(date.getUTCFullYear()) << 5 | Number(date.getUTCMonth());
}
function $a8b2668cf8297c62$export$27b8afa4483e30e(host, start, end) {
    const days = new Map();
    let year = 0;
    for (const date of $a8b2668cf8297c62$export$16352d1b10c5eb38(start, end)){
        if (year != date.getUTCFullYear()) {
            const yearName = (0, $5be042668c706f09$export$c8a8987d4410bf2d)("div", "year-name");
            yearName.textContent = date.getUTCFullYear().toString();
            host.append(yearName);
            if (year === 0 && date.getUTCMonth() != 0) {
                const filler = (0, $5be042668c706f09$export$c8a8987d4410bf2d)("div", "filler");
                filler.style.setProperty("--span", date.getUTCMonth().toString());
                host.append(filler);
            }
            year = date.getUTCFullYear();
        }
        $a8b2668cf8297c62$var$generateMonthVisual(host, date, days);
    }
    return days;
}
function $a8b2668cf8297c62$export$1ff8bac4a7d133b9(days, recorded) {
    for (const [key, value] of recorded.days){
        const el = days.get(key);
        if (el) el.style.setProperty("--intensity", (value / recorded.maxAmount).toString());
        else console.log("no month", key, new Date(key));
    }
}
const $a8b2668cf8297c62$var$DT_FORMAT = new Intl.DateTimeFormat(undefined, {
    dateStyle: "long"
});
function $a8b2668cf8297c62$var$generateMonthVisual(host, start, days) {
    const end = new Date(start);
    end.setUTCMonth(end.getUTCMonth() + 1);
    end.setUTCHours(0, 0, 0, 0);
    start.setUTCHours(0, 0, 0, 0);
    const wrapper = (0, $5be042668c706f09$export$c8a8987d4410bf2d)("div", "month");
    const monthName = (0, $5be042668c706f09$export$c8a8987d4410bf2d)("div", "month-name");
    monthName.textContent = $a8b2668cf8297c62$var$MONTH_MAP[start.getUTCMonth()];
    const monthEl = (0, $5be042668c706f09$export$c8a8987d4410bf2d)("div", "month-visual");
    wrapper.append(monthEl, monthName);
    host.append(wrapper);
    const day = new Date(start);
    const startEl = (0, $5be042668c706f09$export$c8a8987d4410bf2d)("div", "day", `start-day-${day.getUTCDay()}`);
    startEl.style.setProperty("--date", `'${$a8b2668cf8297c62$var$DT_FORMAT.format(day)}'`);
    monthEl.append(startEl);
    days.set(Number(day), startEl);
    day.setUTCDate(day.getUTCDate() + 1);
    for(; day < end; day.setUTCDate(day.getUTCDate() + 1)){
        if (day.getUTCHours() != 0) day.setUTCHours(0, 0, 0, 0);
        const el = (0, $5be042668c706f09$export$c8a8987d4410bf2d)("div", "day");
        el.style.setProperty("--date", `'${$a8b2668cf8297c62$var$DT_FORMAT.format(day)}'`);
        monthEl.append(el);
        days.set(Number(day), el);
    }
}




var $9911c23c83644e6e$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $9911c23c83644e6e$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $9911c23c83644e6e$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $9911c23c83644e6e$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $9911c23c83644e6e$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $9911c23c83644e6e$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $9911c23c83644e6e$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $9911c23c83644e6e$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $9911c23c83644e6e$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $9911c23c83644e6e$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $9911c23c83644e6e$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $9911c23c83644e6e$var$root = $9911c23c83644e6e$var$freeGlobal || $9911c23c83644e6e$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $9911c23c83644e6e$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $9911c23c83644e6e$var$objectToString = $9911c23c83644e6e$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $9911c23c83644e6e$var$nativeMax = Math.max, $9911c23c83644e6e$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $9911c23c83644e6e$var$now = function() {
    return $9911c23c83644e6e$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $9911c23c83644e6e$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($9911c23c83644e6e$var$FUNC_ERROR_TEXT);
    wait = $9911c23c83644e6e$var$toNumber(wait) || 0;
    if ($9911c23c83644e6e$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $9911c23c83644e6e$var$nativeMax($9911c23c83644e6e$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $9911c23c83644e6e$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $9911c23c83644e6e$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($9911c23c83644e6e$var$now());
    }
    function debounced() {
        var time = $9911c23c83644e6e$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $9911c23c83644e6e$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($9911c23c83644e6e$var$FUNC_ERROR_TEXT);
    if ($9911c23c83644e6e$var$isObject(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $9911c23c83644e6e$var$debounce(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $9911c23c83644e6e$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $9911c23c83644e6e$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $9911c23c83644e6e$var$isSymbol(value) {
    return typeof value == "symbol" || $9911c23c83644e6e$var$isObjectLike(value) && $9911c23c83644e6e$var$objectToString.call(value) == $9911c23c83644e6e$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $9911c23c83644e6e$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($9911c23c83644e6e$var$isSymbol(value)) return $9911c23c83644e6e$var$NAN;
    if ($9911c23c83644e6e$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $9911c23c83644e6e$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($9911c23c83644e6e$var$reTrim, "");
    var isBinary = $9911c23c83644e6e$var$reIsBinary.test(value);
    return isBinary || $9911c23c83644e6e$var$reIsOctal.test(value) ? $9911c23c83644e6e$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $9911c23c83644e6e$var$reIsBadHex.test(value) ? $9911c23c83644e6e$var$NAN : +value;
}
$9911c23c83644e6e$exports = $9911c23c83644e6e$var$throttle;


function $131c9e6fae5edc3f$export$51733b8ce8a532d7(datalist, urlEl) {
    const throttledUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($9911c23c83644e6e$exports)))(()=>$131c9e6fae5edc3f$var$updateChannels(datalist, urlEl), 1000);
    urlEl.addEventListener("change", throttledUpdate);
    throttledUpdate();
}
async function $131c9e6fae5edc3f$var$updateChannels(datalist, justlogInput) {
    const channels = await (0, $b187e061564ac6c6$export$6e95cf02744120b)((0, $b187e061564ac6c6$export$8b4efa0639cccf78)(justlogInput.value));
    (0, $5be042668c706f09$export$da51b626bd37c807)(datalist);
    for (const channel of channels){
        const option = (0, $5be042668c706f09$export$c8a8987d4410bf2d)("option");
        option.value = channel.name;
        datalist.append(option);
    }
}


const $b4e14b6b8da86996$var$canvas = document.getElementById("target-canvas");
const $b4e14b6b8da86996$var$canvasCtx = $b4e14b6b8da86996$var$canvas.getContext("2d");
const $b4e14b6b8da86996$var$channelInput = document.getElementById("channel-name");
const $b4e14b6b8da86996$var$usernameInput = document.getElementById("user-name");
const $b4e14b6b8da86996$var$justlogInput = document.getElementById("justlog-url");
const $b4e14b6b8da86996$var$monthsEl = document.getElementById("months");
const $b4e14b6b8da86996$var$hoursEl = document.getElementById("hours");
const $b4e14b6b8da86996$var$reqForm = document.getElementById("req-form");
const $b4e14b6b8da86996$var$dayView = document.getElementById("day-view");
const $b4e14b6b8da86996$var$mainView = document.getElementById("main-view");
const $b4e14b6b8da86996$var$suggestionsEl = document.getElementById("channel-names");
$b4e14b6b8da86996$var$reqForm.addEventListener("submit", (e)=>{
    e.preventDefault();
    $b4e14b6b8da86996$var$runWrapper();
});
(0, $131c9e6fae5edc3f$export$51733b8ce8a532d7)($b4e14b6b8da86996$var$suggestionsEl, $b4e14b6b8da86996$var$justlogInput);
$b4e14b6b8da86996$var$initFields();
let $b4e14b6b8da86996$var$running = false;
function $b4e14b6b8da86996$var$runWrapper() {
    if ($b4e14b6b8da86996$var$running) return;
    $b4e14b6b8da86996$var$running = true;
    $b4e14b6b8da86996$var$run().catch((e)=>alert(e)).finally(()=>$b4e14b6b8da86996$var$running = false);
}
let $b4e14b6b8da86996$var$workerHandler = ()=>undefined;
const $b4e14b6b8da86996$var$worker = (0, $4ee3c9a424eac42e$export$5d455722ec58f172)((res)=>$b4e14b6b8da86996$var$workerHandler(res));
async function $b4e14b6b8da86996$var$run() {
    $b4e14b6b8da86996$var$updateHash();
    const channel = $b4e14b6b8da86996$var$channelInput.value;
    const user = $b4e14b6b8da86996$var$usernameInput.value;
    let userID = "";
    if (user.startsWith("id:")) userID = user.substring(3);
    const justlogUrl = (0, $b187e061564ac6c6$export$8b4efa0639cccf78)($b4e14b6b8da86996$var$justlogInput.value);
    const { logs: logs, capabilities: capabilities } = await (0, $b187e061564ac6c6$export$4e99851808bd6c98)(justlogUrl, channel, user, userID);
    const logList = logs.sort((0, $b187e061564ac6c6$export$b6187d7c6d2d4478));
    if (logList.length === 0) return;
    const start = (0, $b187e061564ac6c6$export$d379edd7759cd0b)(logList[0]);
    const end = (0, $b187e061564ac6c6$export$47fadecd4063c2d1)(logList[logList.length - 1]);
    (0, $5be042668c706f09$export$da51b626bd37c807)($b4e14b6b8da86996$var$monthsEl);
    (0, $a8b2668cf8297c62$export$eb1c2751fdb81cab)($b4e14b6b8da86996$var$monthsEl, new Date(start), end);
    (0, $5be042668c706f09$export$da51b626bd37c807)($b4e14b6b8da86996$var$dayView);
    const dayElements = (0, $a8b2668cf8297c62$export$27b8afa4483e30e)($b4e14b6b8da86996$var$dayView, new Date(start), end);
    $b4e14b6b8da86996$var$canvas.width = (Number(end) - Number(start)) / 86400000;
    $b4e14b6b8da86996$var$canvas.height = $b4e14b6b8da86996$var$hoursEl.clientHeight;
    $b4e14b6b8da86996$var$mainView.classList.remove("hidden");
    const dateMap = $b4e14b6b8da86996$var$makeDateMap(start, end);
    $b4e14b6b8da86996$var$workerHandler = ({ imageHeight: imageHeight, imageWidth: imageWidth, imageBuffer: imageBuffer, recordedDays: recordedDays, dateID: dateID })=>{
        const imageData = new ImageData(new Uint8ClampedArray(imageBuffer), imageWidth, imageHeight);
        $b4e14b6b8da86996$var$canvasCtx.putImageData(imageData, dateMap.get(dateID) ?? 0, 0);
        (0, $a8b2668cf8297c62$export$1ff8bac4a7d133b9)(dayElements, recordedDays);
    };
    $b4e14b6b8da86996$var$worker.postMessage({
        logs: logList,
        height: $b4e14b6b8da86996$var$canvas.height,
        user: user,
        userID: userID,
        channel: channel,
        justlogUrl: justlogUrl,
        hasArbitraryRangeQuery: capabilities.includes("arbitrary-range-query")
    });
}
function $b4e14b6b8da86996$var$makeDateMap(start, end) {
    const map = new Map();
    let x = 0;
    for (const month of (0, $a8b2668cf8297c62$export$16352d1b10c5eb38)(start, end)){
        map.set((0, $a8b2668cf8297c62$export$8deb5bf02e08eae3)(month), x);
        x += (0, $a8b2668cf8297c62$export$3eef6ded89f84b02)(month);
    }
    return map;
}
function $b4e14b6b8da86996$var$initFields() {
    if (location.hash.length < 1) return;
    try {
        const params = new URLSearchParams(location.hash.substring(1));
        const set = (input, key)=>{
            if (params.has(key)) input.value = params.get(key) ?? "";
        };
        set($b4e14b6b8da86996$var$justlogInput, "justlog");
        set($b4e14b6b8da86996$var$channelInput, "channel");
        set($b4e14b6b8da86996$var$usernameInput, "user");
    } catch (e) {
        console.warn("Failed to parse hash", e);
    }
}
function $b4e14b6b8da86996$var$updateHash() {
    const params = new URLSearchParams();
    const put = (input, key)=>{
        if (input.value) params.set(key, input.value);
    };
    put($b4e14b6b8da86996$var$justlogInput, "justlog");
    put($b4e14b6b8da86996$var$channelInput, "channel");
    put($b4e14b6b8da86996$var$usernameInput, "user");
    location.hash = `#${params.toString()}`;
}


//# sourceMappingURL=index.c7837b82.js.map
